<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Número Fiscal</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Inicial"
              v-model="dt_inicio"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Fim"
              v-model="dt_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="embarcacao_id"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Navio</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_viagem"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Viagem</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="des_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Destinatário</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="tom_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Tomador</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="porto_embarque"
              :options="optionsportoEmbarque"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Porto de Origem"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="porto_destino"
              :options="optionsportoDestino"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Porto de Destino"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status_sefaz"
              :options="optionsLivStatusSefaz"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status Sefaz"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="municipio_inicio"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Município Início"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="municipio_fim"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Município Fim"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="modal"
              :options="optionsModal"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Modal"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      helpForm: new Form({ params: [] }),
      num_fiscal: "",
      descr: "",
      optionsPorto: [],
      porto_embarque: [],
      porto_destino: [],
      optionsLivStatus: [],
      status: [],
      num_fiscal: "",
      dt_inicio: "",
      dt_fim: "",
      embarcacao_id: "",
      num_viagem: "",
      des_cnpj: "",
      tom_cnpj: "",
      optionsLivStatusSefaz: [],
      status_sefaz: [],
      optionsMunicipio: [],
      municipio_inicio: [],
      optionsMunicipio: [],
      municipio_fim: [],
      optionsportoEmbarque: [],
      porto_embarque: [],
      optionsportoDestino: [],
      porto_destino: [],
      optionsModal: [],
      modal: [],
      data_filter: []
    };
  },
  mounted() {
    this.getLivGeralFiltros();
    /*this.getLivStatus();
      this.getLivStatusSefaz();
      this.getportoEmbarque();
      this.getportoDestino();
      this.getMunicipio();
      this.getModal();*/
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_inicio_label = this.dt_inicio;
      this.dt_fim_label = this.dt_fim;
      this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
      this.dt_fim = this.formatDateSubmit(this.dt_fim);
      this.data_filter = {
        num_fiscal: this.num_fiscal,
        descr: this.descr,
        status: this.status,
        embarcacao_id: this.embarcacao_id,
        num_viagem: this.num_viagem,
        des_cnpj: this.des_cnpj,
        tom_cnpj: this.tom_cnpj,
        status_sefaz: this.status_sefaz,
        porto_embarque: this.porto_embarque,
        porto_destino: this.porto_destino,
        municipio_inicio: this.municipio_inicio,
        municipio_fim: this.municipio_fim,
        dt_inicio: this.dt_inicio,
        dt_fim: this.dt_fim,
        modal: this.modal
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_inicio = this.dt_inicio_label;
      this.dt_fim = this.dt_fim_label;
    },
    resetFilter() {
      this.num_fiscal = ""; // clear the text in text input
      this.descr = "";
      this.status = "";
      this.embarcacao_id = "";
      this.num_viagem = "";
      this.des_cnpj = "";
      this.tom_cnpj = "";
      this.status_sefaz = "";
      this.porto_embarque = "";
      this.porto_destino = "";
      this.municipio_inicio = "";
      this.municipio_fim = "";
      this.dt_inicio = "";
      this.dt_fim = "";
      this.modal = "";
      this.$events.fire("filter-reset");
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    getLivGeralFiltros() {
      this.helpForm
        .get("/api/gerarmdfe/jsonlistfiltros")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });

          response.sefaz_status.forEach(obj => {
            this.optionsLivStatusSefaz.push({
              label: obj.descr,
              value: obj.valor
            });
          });

          response.portos.forEach(obj => {
            this.optionsportoEmbarque.push({
              label: obj.cd,
              value: obj.porto_id
            });
            this.optionsportoDestino.push({
              label: obj.cd,
              value: obj.porto_id
            });
          });

          response.municipios.forEach(obj => {
            this.optionsMunicipio.push({
              label: obj.nome,
              value: obj.municipio_id
            });
          });

          response.bmodal.forEach(obj => {
            this.optionsModal.push({ label: obj.descr, value: obj.bmodal_id });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    }
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      }
    }
  }
};
</script>
